import {
    Component,
    ElementRef,
    Input
} from '@angular/core';

@Component({
    selector: 'pm-layout-7',
    templateUrl: './layout-7.html'  
})
export class Layout7Component {
   
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-7-component.ts